// plugins/version-watcher.client.ts
export default defineNuxtPlugin(() => {
    const hasUpdate = useState<boolean>('__version_has_update__', () => false);
    const newMeta   = useState<{ time?: string; sha?: string } | null>('__version_meta__', () => null);
    const current   = useState<{ time?: string; sha?: string } | null>('__version_current__', () => null);

    let timer: number | undefined;
    let inFlight = false;
    const onVisChange = () => { if (!document.hidden) { void check(); } };

    async function fetchMeta() {
        try {
            // 캐시 버스트 쿼리 파라미터로 프록시/중간 캐시까지 우회
            const url = `/build.json?cb=${Date.now()}`;
            const res = await fetch(url, { cache: 'no-store' });
            if (!res.ok) { return null; }

            // 비어있거나 JSON 아님을 대비
            const json = await res.json().catch(() => null);
            if (!json || (typeof json.sha !== 'string' && typeof json.time !== 'string')) {
                return null;
            }

            const meta = {
                time: typeof json.time === 'string' ? json.time : null,
                sha:  typeof json.sha  === 'string' ? json.sha  : null,
            } as { time: string | null; sha: string | null };

            // 안전한 localStorage 저장 (표준 API 사용)
            try {
                if (meta.sha)  { localStorage.setItem('frontendCommitVersion', meta.sha); }
                if (meta.time) { localStorage.setItem('frontendBuildTime',   meta.time); }
            } catch { /* storage quota 등 무시 */ }

            // 필수 키가 둘 다 없다면 null 반환
            if (!meta.time && !meta.sha) { return null; }
            return { time: meta.time ?? '', sha: meta.sha ?? '' };
        } catch {
            return null;
        }
    }

    async function check() {
        if (inFlight) { return; }
        inFlight = true;
        try {
            const meta = await fetchMeta();
            if (!meta) { return; }

            // 최초 기록
            if (!current.value) {
                current.value = meta;
                return;
            }

            // 변경 감지
            const changed = meta.time !== current.value.time || meta.sha !== current.value.sha;
            if (changed) {
                newMeta.value = meta;
                hasUpdate.value = true;
                // 다음 폴링에서 재알림 방지
                current.value = meta;
            }
        } finally {
            inFlight = false;
        }
    }

    // 첫 체크 + 주기 폴링 (3초는 과함; 30초 권장)
    void check();
    timer = window.setInterval(() => { void check(); }, 30_000);

    document.addEventListener('visibilitychange', onVisChange);

    // HMR/핫리로드 시 정리
    if (import.meta.hot) {
        import.meta.hot.dispose(() => {
            if (timer) { clearInterval(timer); }
            document.removeEventListener('visibilitychange', onVisChange);
        });
    }
});
